import useAppSelector from 'hooks/useAppSelector';
import { ImageExtension } from 'microshop-api';
import { selectFeaturedCategories } from 'store/reducers/assortmentSlice';
import styled from 'styled-components';
import getImage from 'utils/getImage';
import Text from '../Text';
import { selectFeaturedCategoriesInfo } from 'store/reducers/shopSlice';
import CardSection, { Card, CardImage, CardImageFrame, CardImageLink } from './CardSection';

const FeaturedCategories = () => {
    const featuredCategories = useAppSelector(selectFeaturedCategories);
    const featuredCategoriesInfo = useAppSelector(selectFeaturedCategoriesInfo);

    if (!featuredCategories.length || !featuredCategoriesInfo?.enabled) return null;

    return (
        <CardSection title={featuredCategoriesInfo?.title} arrowVerticalPosition="35%">
            {featuredCategories.map((cat) => (
                <Card key={`cat-${cat.code}`}>
                    <CardImageLink to={`/${cat?.assortmentSlug}`}>
                        <CardImageFrame $aspectRatio="16 / 11">
                            <CardImage src={getImage(cat?.picture, ImageExtension.Jpg)} alt={cat.name ?? ''} />
                        </CardImageFrame>
                    </CardImageLink>
                    <Name bold>{cat.name}</Name>
                    {cat.description && <Description>{cat.description}</Description>}
                </Card>
            ))}
        </CardSection>
    );
};

const Name = styled(Text)`
    text-align: center;
    width: 100%;
    font-weight: 700;
`;

const Description = styled(Text)`
    text-align: center;
    width: 100%;
    font-size: 0.8em;
`;

export default FeaturedCategories;
